__turbopack_context__.v({
  "quote": "V74uUa_quote",
  "quote-card": "V74uUa_quote-card",
  "quote-card__author": "V74uUa_quote-card__author",
  "quote-card__text": "V74uUa_quote-card__text",
});
